export const getLocalString = (locales, localName) => {
    return locales?.[localName]||localName;
}
export const localNames = {
    LOGIN_PAGE_LOGINBUTTON : 'login.page.loginButton',
    LOGIN_PAGE_TITLE : 'login.page.title',
    LOGIN_PAGE_PASSWORDREQUEST : 'login.page.passwordRequest',
    LOGIN_PAGE_REMEMBERBUTTON : 'login.page.rememberButton',
    LOGIN_PAGE_FORGOTPASSBUTTON : 'login.page.forgotPassButton',
    LOGIN_PAGE_NOACCOUNT : 'login.page.noAccount',
    LOGIN_PAGE_REQUESTBUTTON : 'home.page.requestButton',
    LOGIN_PAGE_APPLICATIONLOGIN :'login.page.applicationLogin',
    LOGIN_PAGE_TEXT1 :'login.page.text1',
    LOGIN_PAGE_TEXT2 :'login.page.text2',
    LOGIN_PAGE_TAXISLOGIN :'login.page.taxisLogin',
    LOGIN_PAGE_ENTERUSERNAME :'login.page.enterUsername',
    LOGIN_PAGE_ENTERPASSWORD :'login.page.enterPassword',
    LOGIN_PAGE_ENTER :'login.page.enter',
    LOGIN_PAGE_ADMINISTRATORLOGIN :'login.page.administratorLogin',
    FORGOTPASSWORD_PAGE_FORGOTPASS: 'forgotPassword.page.forgotPass',
    FORGOTPASSWORD_PAGE_EMAIL: 'forgotPassword.page.email',
    FORGOTPASSWORD_PAGE_SUBMIT: 'forgotPassword.page.submit',
    FORGOTPASSWORD_PAGE_BACK: 'forgotPassword.page.back',
    FORGOTPASSWORD_PAGE_ENTEREMAILFORNEWPASS: 'forgotPassword.page.enterEmailForNewPass',
    HOME_PAGE_RESULTTABLE : 'home.page.resultTable',
    HOME_PAGE_RESULTTABLE_CODE : 'home.page.resultTable.code',
    HOME_PAGE_RESULTTABLE_DESCRIPTION : 'home.page.resultTable.description',
    HOME_PAGE_RESULTTABLE_EMPLOYEENAME : 'home.page.resultTable.employeeName',
    HOME_PAGE_RESULTTABLE_EMPLOYEECODE : 'home.page.resultTable.employeeCode',
    HOME_PAGE_RESULTTABLE_DEPARTMENT : 'home.page.resultTable.department',
    HOME_PAGE_RESULTTABLE_APPROVALSTAGE : 'home.page.resultTable.approvalStage',
    HOME_PAGE_RESULTTABLE_TOTALVALUE : 'home.page.resultTable.totalValue',
    HOME_PAGE_RESULTTABLE_DATE : 'home.page.resultTable.date',
    HOME_PAGE_SEARCH : 'home.page.search',
    HOME_PAGE_SEARCHFP : 'home.page.searchfp',
    HOME_PAGE_SEARCHNP : 'home.page.searchnp',
    HOME_PAGE_SEARCHKTP : 'home.page.searchktp',
    HOME_PAGE_SEARCHPROVIDER : 'home.page.searchProvider',
    HOME_PAGE_LOGOUT : 'home.page.logout',
    HOME_PAGE_FILTERSBUTTON : 'home.page.filtersButton',
    HOME_PAGE_FILTERS_EMPLOYEECODE : 'home.page.filters.employeeCode',
    HOME_PAGE_FILTERS_EMPLOYEENAME : 'home.page.filters.employeeName',
    HOME_PAGE_FILTERS_DEPARTMENT : 'home.page.filters.department',
    HOME_PAGE_FILTERS_RECEIPTCODE : 'home.page.filters.receiptCode',
    HOME_PAGE_FILTERS_RECEIPTDESCRIPTION : 'home.page.filters.receiptDescription',
    HOME_PAGE_FILTERS_RECEIPTAPPROVALSTAGE : 'home.page.filters.receiptApprovalStage',
    HOME_PAGE_FILTERS_VALUE : 'home.page.filters.value',
    HOME_PAGE_FILTERS_DATEFROM : 'home.page.filters.dateFrom',
    HOME_PAGE_FILTERS_DATETO : 'home.page.filters.dateTo',
    ADMIN_PAGE_RESULTTABLE : 'admin_page_resultTable',
    REQUEST_PAGE_ADDCOMMENT : 'request.page.addComment',
    REQUEST_PAGE_CANCEL : 'request.page.cancel',
    REQUEST_PAGE_ADD : 'request.page.add',
    REQUEST_PAGE_SUBMISSIONBUTTON : 'request.page.submissionButton',
    REQUEST_PAGE_SAVEBUTTON : 'request.page.saveButton',
    REQUEST_PAGE_RECEIPTINFO : 'request.page.receiptInfo',
    REQUEST_PAGE_APPROVALWORKFLOW : 'request.page.approvalWorkflow',
    REQUEST_PAGE_APPROVALWORKFLOW_RECEIPTENTRY : 'request.page.approvalWorkflow.receiptEntry',
    REQUEST_PAGE_APPROVALWORKFLOW_APPROVERCHECK : 'request.page.approvalWorkflow.approverCheck',
    REQUEST_PAGE_APPROVALWORKFLOW_LEDGERAUDIT : 'request.page.approvalWorkflow.ledgerAudit',
    REQUEST_PAGE_APPROVALWORKFLOW_COMPLETION : 'request.page.approvalWorkflow.completion',
    REQUEST_PAGE_APPROVALWORKFLOW_PROCESSSTART : 'request.page.approvalWorkflow.processStart',
    REQUEST_PAGE_APPROVALWORKFLOW_APPROVERDECISION : 'request.page.approvalWorkflow.approverDecision',
    REQUEST_PAGE_APPROVALWORKFLOW_LEDGERDECISION : 'request.page.approvalWorkflow.ledgerDecision',
    REQUEST_PAGE_RECEIPT : 'request.page.receipt',
    REQUEST_PAGE_RECEIPT_ELEMENTS : 'request.page.receipt.elements',
    REQUEST_PAGE_RECEIPT_DESCRIPTION : 'request.page.receipt.description',
    REQUEST_PAGE_RECEIPT_DESCRIPTIONINSERT : 'request.page.receipt.descriptionInsert',
    REQUEST_PAGE_RECEIPT_NAME : 'request.page.receipt.name',
    REQUEST_PAGE_RECEIPT_NAMEINSERT : 'request.page.receipt.nameInsert',
    REQUEST_PAGE_RECEIPT_CODE : 'request.page.receipt.code',
    REQUEST_PAGE_RECEIPT_CODEINSERT : 'request.page.receipt.codeInsert',
    REQUEST_PAGE_RECEIPT_DEPARTMENT : 'request.page.receipt.department',
    REQUEST_PAGE_RECEIPT_DEPARTMENTINSERT : 'request.page.receipt.departmentInsert',
    REQUEST_PAGE_RECEIPT_TOTALVALUE : 'request.page.receipt.totalValue',
    REQUEST_PAGE_RECEIPT_TOTALVALUEINSERT : 'request.page.receipt.totalValueInsert',
    REQUEST_PAGE_RECEIPT_RECEIPTPERIOD : 'request.page.receipt.receiptPeriod',
    REQUEST_PAGE_RECEIPT_RECEIPTPERIODFROMINSERT : 'request.page.receipt.receiptPeriodFromInsert',
    REQUEST_PAGE_RECEIPT_RECEIPTPERIODTOINSERT : 'request.page.receipt.receiptPeriodToInsert2',
    REQUEST_PAGE_RECEIPT_APPROVALDATE : 'request.page.receipt.approvalDate',
    REQUEST_PAGE_RECEIPT_APPROVALDATEINSERT : 'request.page.receipt.approvalDateInsert',
    REQUEST_PAGE_OUTPUTLINE : 'request.page.outputLine',
    REQUEST_PAGE_OUTPUTLINE_JUSTIFICATIONCOMMENT : 'request.page.outputLine.justification-comments',
    REQUEST_PAGE_OUTPUTLINE_PAYMENTMETHOD : 'request.page.outputLine.paymentMethod',
    REQUEST_PAGE_OUTPUTLINE_EXPENSEDESCRIPTION : 'request.page.outputLine.expenseDescription',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTTYPE : 'request.page.outputLine.documentType',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTNUMBER : 'request.page.outputLine.documentNumber',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTVALUE : 'request.page.outputLine.documentValue',
    REQUEST_PAGE_OUTPUTLINE_NETVALUE : 'request.page.outputLine.netValue',
    REQUEST_PAGE_OUTPUTLINE_TAXIDENTIFICATIONNUMBER : 'request.page.outputLine.taxIdentificationNumber',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTDATE : 'request.page.outputLine.documentDate',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTDATESUBMIT : 'request.page.outputLine.documentDateSubmit',
    REQUEST_PAGE_OUTPUTLINE_COSTCENTER : 'request.page.outputLine.costCenter',
    REQUEST_PAGE_OUTPUTLINE_SUPPLIERSCREDITORS : 'request.page.outputLine.suppliers-creditors',
    REQUEST_PAGE_OUTPUTLINE_CANCELBUTTON : 'request.page.outputLine.cancelButton',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTADDITIONBUTTON : 'outputLine.documentAdditionButton',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTEDITBUTTON : 'request.page.outputLine.documentEditButton',
    REQUEST_PAGE_OUTPUTLINE_LINECODE : 'request.page.outputLine.lineCode',
    REQUEST_PAGE_OUTPUTLINE_TYPEDOCUMENT : 'request.page.outputLine.typeDocument',  
    REQUEST_PAGE_OUTPUTLINE_GENERALACCOUNTINGACCOUNT : 'request.page.outputLine.generalAccountingAccount',
    REQUSET_PAGE_OUTPUTLINE_NETAMMOUNT : 'request.page.outputLine.netAmmount',
    REQUEST_PAGE_OUTPUTLINE_VAT : 'request.page.outputLine.vat',
    REQUEST_PAGE_OUTPUTLINE_VALUEWITHVAT : 'request.page.outputLine.valueWithVat',
    REQUEST_PAGE_OUTPUTLINE_ADDCOMMENT : 'request.page.addComment',
    REQUEST_PAGE_OUTPUTLINE_UNIT : 'request.page.outputLine.unit',
    // REQUEST_PAGE_CANCEL : 'request.page.cancel',
    // REQUEST_PAGE_ADD : 'request.page.add',
    REQUEST_PAGE_OUTPUTLINE_PAYMENTMETHOD_CASH : 'request.page.outputLine.paymentMethod.cash',
    REQUEST_PAGE_OUTPUTLINE_PAYMENTMETHOD_CREDITCARD : 'request.page.outputLine.paymentMethod.creditCard',
    REQUEST_PAGE_OUTPUTLINE_PAYMENTMETHOD_BANKDEPOSIT : 'request.page.outputLine.paymentMethod.bankDeposit',
    REQUEST_PAGE_OUTPUTLINE_PAYMENTMETHOD_DELIVERY : 'request.page.outputLine.paymentMethod.delivery',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTTYPE_RECEIPT : 'request.page.outputLine.documentType.receipt',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTTYPE_INVOICE : 'request.page.outputLine.documentType.invoice',
    REQUEST_PAGE_OUTPUTLINE_DOCUMENTTYPE_OTHER : 'request.page.outputLine.documentType.other',
    REQUEST_PAGE_DOCUMENTS : 'request.page.documents',
    REQUEST_PAGE_DOCUMENTS_DOCUMENTPOST : 'request.page.documents.documentPost',
    REQUEST_PAGE_DOCUMENTS_PAPERS : 'request.page.documents.papers',
    REQUEST_PAGE_DOCUMENTS_PAPERSDATE : 'request.page.documents.papersDate',
    REQUEST_PAGE_DOCUMENTS_PAPERSDATEINSERT : 'request.page.documents.papersDateInsert',
    REQUEST_PAGE_DOCUMENTS_PAPERSOUTPUTLINECODE : 'request.page.documents.papersOutputLineCode',
    REQUEST_PAGE_DOCUMENTS_PAPERSOUTPUTLINECODEINSERT : 'request.page.documents.papersOutputLineCodeInsert',
    REQUEST_PAGE_DOCUMENTS_PAPERSDESCRIPTION : 'request.page.documents.papersDescription',
    REQUEST_PAGE_DOCUMENTS_PAPERSDESCRIPTIONINSERT : 'request.page.documents.papersDescriptionInsert',
    REQUEST_PAGE_DOCUMENTS_PAPERSADDITIONBUTTON : 'request.page.documents.papersAdditionButton',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTS : 'request.page.documents.otherDocuments',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTDATE : 'request.page.documents.otherDocumentDate',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTDATEINSERT : 'request.page.documents.otherDocumentDateInsert',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTS_OUTPUTLINECODE : 'request.page.documents.otherDocumentOutputLineCode',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTOUTPUTLINECODEINSERT : 'request.page.documents.otherDocumentOutputLineCodeInsert',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTDESCRIPTION : 'request.page.documents.otherDocumentDescription',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTDESCRIPTIONINSERT : 'request.page.documents.otherDocumentDescriptionInsert',
    REQUEST_PAGE_DOCUMENTS_OTHERDOCUMENTADDITIONBUTTON : 'request.page.documents.otherDocumentAdditionButton',
    REQUEST_PAGE_HISTORICITY : 'request.page.historicity',
    REQUEST_PAGE_RECEIPTPERIOD : 'request.page.receiptPeriod',
    REQUEST_PAGE_PREVIOUSBUTTON : 'request.page.previousButton',
    REQUEST_PAGE_NEXTBUTTON : 'request.page.nextButton',
    REQUEST_PAGE_RETURN : 'request.page.returnButton',
    REQUEST_STATUS_INPROGRESS : 'request.status.inProgress',
    REQUEST_STATUS_SUBMITAPPLICATION: 'request.status.submitApplication',
    REQUEST_STATUS_AUDITAPPLICATIONFIRST: 'request.status.auditApplicationFirst',
    REQUEST_STATUS_AUDITAPPLICATIONSECOND: 'request.status.auditApplicationSecond',
    REQUEST_STATUS_REJECTAPPLICATION: 'request.status.rejectApplication',
    REQUEST_STATUS_PAYMENT: 'request.status.payment',
    REQUEST_PAGE_OUTLINE_APPROVE: 'request.page.outputLine.approve',
    REQUEST_PAGE_OUTLINE_REJECT: 'request.page.outputLine.reject',
    REQUEST_PAGE_RESULTTABLE_DELETE: 'home.page.resultTable.delete',
    REQUEST_PAGE_RESULTTABLE_EDIT: 'home.page.resultTable.edit',    
    REQUEST_PAGE_RESULTTABLE_VIEW: 'home.page.resultTable.view',
    REQUEST_PAGE_DOCUMENTS_DRAGANDDROP: 'request.page.documents.dragAndDrop',
    REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD2: 'request.page.documents.clickToUpload2',
    REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD: 'request.page.documents.clickToUpload',
    TASK_NAME_SUBMITAPPLICATION:'task.name.submit_application',
    TASK_NAME_AUDITAPPLICATION:'task.name.audit_application',
    TASK_NAME_CREATEVOUCHER:'task.name.create_voucher',
    TASK_NAME_AUDITREJECTION:'task.name.audit_rejection',
    TASK_NAME_CANCELAPPLICATION:'task.name.cancel_application',
    TASK_NAME_PROGRAMIMPLEMENTATION:'task.name.program_implementation',
    TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETE:'task.name.program_implementation_complete',
    TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETEWITHAPPROVAL:'task.name.complete_application_with_approval',
    TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETEWITHOUTAPPROVAL:'task.name.complete_application_without_approval',
    TASK_NAME_OBJECTION_SUMBIT:'task.name.sumbit_objection',
    TASK_NAME_OBJECTION_AUDIT:'task.name.audit_objection',
    TASK_NAME_COMPLETE_REQUEST:'task.name.complete_application_request',
    TASK_NAME_COMPLETE_TOPAY:'task.name.complete_application_for_payment',
    TASK_NAME_PAYMENT_REJECT:'task.name.reject_payment',
    TASK_NAME_PAYMENT_APPROVE:'task.name.accept_payment',
    TASK_NAME_CANCEL_VOUCHER:'task.name.voucher_cancel',
    // PROVIDER
    HOME_PAGE_PROVIDER_BUTTON_STATUS:'home.page.provider.button.status',
    HOME_PAGE_PROVIDER_TABLE_TITLE:'home.page.provider.table.title',
    HOME_PAGE_PROVIDER_TABLE_UPLOAD_TITLE:'home.page.provider.table.uploadTitle',
    HOME_PAGE_PROVIDER_TABLE_ID:'home.page.provider.table.id',
    HOME_PAGE_PROVIDER_TABLE_DAYTIME:'home.page.provider.table.dayTime',
    HOME_PAGE_PROVIDER_TABLE_USER:'home.page.provider.table.user',
    HOME_PAGE_PROVIDER_TABLE_STATUS:'home.page.provider.table.status',
    HOME_PAGE_PROVIDER_TABLE_STATUS_COMPLETED:'home.page.provider.table.status.completed',
    HOME_PAGE_PROVIDER_TABLE_STATUS_COMPLETEDWITHERRORS:'home.page.provider.table.status.completedWithErrors',
    HOME_PAGE_PROVIDER_TABLE_STATUS_UNSUCCESSFUL:'home.page.provider.table.status.unsuccessful',
    HOME_PAGE_PROVIDER_TABLE_COMPLETED_UPDATES:'home.page.provider.table.completedUpdates',
    HOME_PAGE_PROVIDER_TABLE_FAILED_UPDATES:'home.page.provider.table.failedUpdates',
    HOME_PAGE_PROVIDER_TABLE_FILENAME:'home.page.provider.table.filename',
    HOME_PAGE_PROVIDER_TABLE_ACTIONS:'home.page.provider.table.actions',
    HOME_PAGE_PROVIDER_ACTION_DOWNLOAD:'home.page.provider.action.download',
    HOME_PAGE_PROVIDER_ACTION_SUCCESS:'home.page.provider.action.success',
    HOME_PAGE_PROVIDER_ACTION_FAILED:'home.page.provider.action.failed',







}